module.exports = __webpack_public_path__ + "images/UFC_logo_white-382d6a960f22e52f6dc53c2fcd1f8adf.svg";